import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import GoogleButton from "@/components/GoogleButton";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [accept, setAccept] = useState(false);
  const [loading, setLoading] = useState(false);
  const [params] = useSearchParams();
  const referral = params.get("ref") || "";
  const { register , googleLogin } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!accept) { toast.error("Kullanım şartlarını kabul etmelisin"); return; }
    setLoading(true);
    try {
      await register(email, password, name, referral);
      toast.success("Hoş geldin! 15 jeton hesabına yüklendi ✧");
      navigate("/panel");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Kayıt başarısız");
    } finally {
      setLoading(false);
    }
  };


  const onGoogle = async (credential) => {
    try {
      const data = await googleLogin(credential);
      toast.success(data.new_user ? "Hoş geldin! 15 jeton hesabına yüklendi ✧" : "Hoş geldin!");
      navigate("/panel");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Google girişi başarısız");
    }
  };

  return (
    <div className="cosmic-bg min-h-screen flex items-center justify-center px-4 py-12">
      <div className="stars" />
      <div className="w-full max-w-md fade-up">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <Sparkles className="w-7 h-7 gold-text" />
          <span className="font-serif-myst text-3xl font-semibold">FalZilla</span>
        </Link>

        <div className="glass rounded-3xl p-8">
          <h1 className="font-serif-myst text-3xl mb-2 text-center">Ücretsiz Kayıt Ol</h1>
          <p className="text-white/60 text-center text-sm mb-6">Kayıt hediyesi: <span className="gold-text font-semibold">15 jeton</span></p>

          <GoogleButton onCredential={onGoogle} text="signup_with" />
          <div className="text-center text-xs text-white/40 my-4">— veya —</div>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs text-white/60 mb-1 block">Ad</label>
              <input
                type="text"
                required
                minLength={2}
                value={name}
                onChange={(e) => setName(e.target.value)}
                data-testid="register-name-input"
                className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder:text-white/30 focus:outline-none focus:border-[#D4AF37]/50 transition-colors"
                placeholder="Adın"
              />
            </div>
            <div>
              <label className="text-xs text-white/60 mb-1 block">E-posta</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="register-email-input"
                className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder:text-white/30 focus:outline-none focus:border-[#D4AF37]/50 transition-colors"
                placeholder="ornek@mail.com"
              />
            </div>
            <div>
              <label className="text-xs text-white/60 mb-1 block">Şifre (min 6)</label>
              <input
                type="password"
                required
                minLength={6}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="register-password-input"
                className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder:text-white/30 focus:outline-none focus:border-[#D4AF37]/50 transition-colors"
                placeholder="••••••••"
              />
            </div>
            {referral && (
              <div className="text-xs gold-text">Davet kodu: {referral}</div>
            )}
            <label className="flex items-start gap-2 text-xs text-white/60">
              <input
                type="checkbox"
                checked={accept}
                onChange={(e) => setAccept(e.target.checked)}
                data-testid="register-accept-checkbox"
                className="mt-0.5 accent-[#D4AF37]"
              />
              <span>
                Uygulamanın <strong>yalnızca eğlence amaçlı</strong> olduğunu, 18+ olduğumu ve <a href="/kullanim" className="gold-text hover:underline">kullanım şartlarını</a> kabul ediyorum.
              </span>
            </label>
            <button type="submit" disabled={loading} data-testid="register-submit-btn" className="btn-gold w-full py-3 rounded-xl">
              {loading ? "Kaydediliyor..." : "Kayıt Ol"}
            </button>
          </form>

          <div className="text-center text-sm text-white/60 mt-6">
            Zaten hesabın var mı? <Link to="/giris" data-testid="register-goto-login" className="gold-text hover:underline">Giriş yap</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
